// import firebase from "firebase/app";
// import "firebase/firestore";
// import "firebase/analytics";
// import "firebase/auth"

import { Observable } from "rxjs";

import Util from "@/helper/Utility.js";
import ConfigManager from "@/config/ConfigManager.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
import ConfigScript from "@/config/ConfigScript";

export default {
    install: (app) => {
        

        let config = ConfigManager.getFirebaseSetup();

        let firebaseAnalytics = null;
        let firebaseAuth = null;

        let trackingInit = false;

        const obserInitfirebase = new Observable((subscriber) => {
            if (trackingInit) {
                subscriber.next(true);
            } else {
                subInitList.push(subscriber);
            }
        });
        const subInitList = [];

        if (config.apiKey) {
            const configScript = new ConfigScript()
            configScript.useFirebase().then(async () => {
                await window.initFirebase(config);
                if (!window.isLockdown.isLockdownEnabled()) {
                    window.initAnalytics();
                }

                trackingInit = true;
                for (let i of subInitList) {
                    i.next(true);
                }
            });
            // firebase.initializeApp(config);
            // firebase.analytics();
            // firebaseAnalytics = firebase.analytics();

            // firebaseAuth = firebase.auth();
            // firebaseAuth.useDeviceLanguage()
        } else {
            trackingInit = true;
            for (let i of subInitList) {
                i.next(true);
            }
        }

        const tracking = new TrackingService(firebaseAnalytics);


        app.provide('firebaseAuth', firebaseAuth)
        app.provide('trackingService', tracking)

        app.mixin({
            data: function () {
                return {
                    firebaseTrack: firebaseAnalytics,
                    tracking: null,
                    trackingInit: false,
                    obserInitfirebase: null,
                }
            },
            created: function () {
                this.tracking = tracking;
                this.trackingInit = trackingInit;
                this.obserInitfirebase = obserInitfirebase;

                this.obserInitfirebase.subscribe((status) => {
                    if (status) {
                        if (Util.isFunction(this.onTrackingInit)) {
                            this.onTrackingInit();
                        }
                    }
                });
            },
        });
    },
};
